import { CommonModule } from '@angular/common';
import { Component, effect, inject, Input } from '@angular/core';
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { LocaleService } from 'src/app/services/locale';
import { APIService } from 'src/app/services/api';

@Component({
  imports: [CommonModule],
  selector: 'report-payment-section',
  template: `
    <div class="flex flex-col gap-4 justify-center items-center">
      <div class="text-sm text-[#616161]">{{ text }} logo</div>
      <div
        [ngStyle]="{
          backgroundImage: 'url(' + logo || defaultLogo + ')'
        }"
        class="h-24 w-24 bg-center bg-cover rounded-full"
      ></div>
      <div
        *ngIf="!selected && !logoSelected"
        (click)="payForLogo(logo || defaultLogo)"
        class="px-4 py-2 rounded-lg text-[#043b22] border border-[#043b22] cursor-pointer hover:bg-[#043b22] hover:text-white"
      >
        {{ locale.report.set_in_report }}
      </div>
      <div
        *ngIf="selected"
        (click)="removeLogo()"
        class="px-4 py-2 rounded-lg text-red-500 border border-red-500 cursor-pointer hover:bg-red-500 hover:text-white"
      >
        {{ locale.report.remove_from_report }}
      </div>
    </div>
  `
})
export class PaymentSection {
  @Input() text = '';
  @Input() logo: any = null;
  @Input() selected = false;
  @Input() logoSelected: any;
  @Input() selectLogo: any;
  @Input() resetLogo: any;

  private localeService = inject(LocaleService);
  locale = this.localeService.locale();

  private api = inject(APIService);

  constructor(private spinner: NgxSpinnerService) {
    effect(() => {
      this.locale = this.localeService.locale();
    });
  }

  defaultLogo = '/images/welcome.png';

  logoPrice = environment.stripePrices.logo;
  reportPrice = environment.stripePrices.report;

  paidForLogo = false;

  setLogo = (img: any) => {
    localStorage.setItem('setLogo', img);
    this.selected = true;
    this.selectLogo();
  };

  removeLogo = () => {
    localStorage.removeItem('setLogo');
    this.selected = false;
    this.resetLogo();
  };

  payForLogo = async (img: any) => {
    // Re-check DB for latest paidForLogo status
    const calculationId = localStorage.getItem('calculationId');
    if (calculationId) {
      try {
        const result = await this.api.GetCompanyDetails(calculationId);
        this.paidForLogo = !!result?.paidForLogo;
      } catch (e) {}
    }

    if (this.paidForLogo) {
      this.setLogo(img);
      return;
    }

    this.spinner.show();

    try {
      const [userAttributes, session] = await Promise.all([fetchUserAttributes(), fetchAuthSession()]);
      const token = session.tokens?.idToken?.toString() ?? '';
      const response = await fetch(environment.lambdaUrls.stripe, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          email: userAttributes.email,
          action: 'create_checkout_session',
          mode: 'payment',
          priceId: this.logoPrice,
          successUrl: `${environment.baseUrl}/calculation?paid=${this.logoPrice}`,
          cancelUrl: `${environment.baseUrl}/calculation?paid=nonced`
        })
      });

      const result = await response.json();
      if (!response.ok || !result.url) throw new Error(result.error || 'Failed to create checkout session');
      window.location.href = result.url;
    } catch (error) {
      this.spinner.hide();
      console.error('Error creating checkout session:', error);
    }
  };
}
